//ResourceTypes
export const TransactionActionTypes = {
  ASYNC_TRANSACTION_DETAILS: '@transactions/ASYNC_TRANSACTION_DETAILS',
  CHANGE_TRANSACTION_DETAILS: '@transactions/CHANGE_TRANSACTION_DETAILS',
  LOADING_TRANSACTION_DETAILS: '@transactions/LOADING_TRANSACTION_DETAILS',
  ASYNC_TRANSACTIONS_LATEST: '@schedule/ASYNC_TRANSACTIONS_LATEST',
  CHANGE_TRANSACTIONS_LATEST: '@schedule/CHANGE_TRANSACTIONS_LATEST',
  ASYNC_TRANSACTIONS_SUMMARY: '@schedule/ASYNC_TRANSACTIONS_SUMMARY',
  CHANGE_TRANSACTIONS_SUMMARY: '@schedule/CHANGE_TRANSACTIONS_SUMMARY',
  LOADING_TRANSACTIONS_SUMMARY: '@schedule/LOADING_TRANSACTIONS_SUMMARY'
};

const INITIAL_STATE = {
  transaction_details: {},
  loading_details: false,
  transactionsLatest: [],
  transactionsSummary: [],
  loadingSummary: false,
}

const TransactionReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case TransactionActionTypes.CHANGE_TRANSACTION_DETAILS:
      return { ...state, transaction_details: payload };
    case TransactionActionTypes.LOADING_TRANSACTION_DETAILS:
      return { ...state, loading_details: payload };
    case TransactionActionTypes.CHANGE_TRANSACTIONS_LATEST:
      return { ...state, transactionsLatest: payload};
    case TransactionActionTypes.CHANGE_TRANSACTIONS_SUMMARY:
      return { ...state, transactionsSummary: payload}
    case TransactionActionTypes.LOADING_TRANSACTIONS_SUMMARY:
      return { ...state, loadingSummary: payload}
    default:
      return state;
  }
}

//Actions
export const asyncTransactionDetails = (paymentId) => ({
  type: TransactionActionTypes.ASYNC_TRANSACTION_DETAILS,
  payload: paymentId
});

export const changeTransactionDetails = (transaction) => ({
  type: TransactionActionTypes.CHANGE_TRANSACTION_DETAILS,
  payload: transaction
});

export const loadingTransactionDetails = (loading) => ({
  type: TransactionActionTypes.LOADING_TRANSACTION_DETAILS,
  payload: loading
});

export const asyncTransactionsLatest = (payload) => ({
  type: TransactionActionTypes.ASYNC_TRANSACTIONS_LATEST,
  payload,
});

export const changeTransactionsLatest = (payload) => ({
  type: TransactionActionTypes.CHANGE_TRANSACTIONS_LATEST,
  payload,
});

export const asyncTransactionsSummary = (payload) => ({
  type: TransactionActionTypes.ASYNC_TRANSACTIONS_SUMMARY,
  payload,
});

export const changeTransactionsSummary = (payload) => ({
  type: TransactionActionTypes.CHANGE_TRANSACTIONS_SUMMARY,
  payload,
});

export const loadingTransactionsSummary = (payload) => ({
  type: TransactionActionTypes.LOADING_TRANSACTIONS_SUMMARY,
  payload,
});

export default TransactionReducer;
